import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/capture-storage/blob/")({
  staticData: {
    title: "common.blob",
  },
  loader: () => redirect({ to: "/storage-hub/capture-storage" }),
});
